import { getListOfLoginSessions } from "../types/account_sessions_types";

const initState = {
    data: [],
    count: 0,
    loading: false,
    error: null,
};

export default function accountLoginSessionsReducer(state = initState, action = {}) {
    switch (action.type) {
        case getListOfLoginSessions.REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case getListOfLoginSessions.SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                count: action.payload.count,
                error: null,
            };
        case getListOfLoginSessions.FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
